<template>
  <div class="kingster-top-bar">
    <div class="kingster-top-bar-background"></div>
    <div class="kingster-top-bar-container kingster-container ">
      <div class="kingster-top-bar-container-inner clearfix">
        <div class="kingster-top-bar-left kingster-item-pdlr">
          <i class="fa fa-envelope-open-o" id="i_fd84_0"></i>
          {{ meta.email }}
          <i class="fa fa-phone" id="i_fd84_1"></i> {{ meta.phone }}
        </div>
        <div class="kingster-top-bar-right kingster-item-pdlr">
          <!-- <ul
            id="kingster-top-bar-menu"
            class="sf-menu kingster-top-bar-menu kingster-top-bar-right-menu"
          >
            <li class="menu-item kingster-normal-menu">
              <a href="#">Alumni</a>
            </li>
            <li class="menu-item kingster-normal-menu">
              <a href="#">Calendar</a>
            </li>
            <li class="menu-item kingster-normal-menu">
              <a href="#">Portal</a>
            </li>
          </ul> -->
          <div class="kingster-top-bar-right-social"></div>
          <a class="kingster-top-bar-right-button" href="#" target="_blank"
            >Support KU</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TopBar",
  props: ["meta"],

  mounted() {},
};
</script>
<style lang="css">
@import "../../../../assets/css/template4/style-core.css";
@import "../../../../assets/css/template4/kingster-style-custom.css";
</style>
